import services from '@/services.js'

export default {}
